(function () {
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeEls = document.querySelectorAll('[data-drawer-close]');

  if (!drawer || !openBtn) return;

  function openDrawer() {
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openDrawer);
  closeEls.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
